import React, { useState, useEffect } from 'react';
import { ArrowRight } from 'lucide-react';

export default function Nav({ onJoin }) {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return (
    <header
      className={`fixed top-0 left-0 right-0 z-40 transition-[background,backdrop-filter,border] duration-300 ${
        scrolled
          ? 'bg-[#F5F2EC]/85 backdrop-blur-md border-b border-black/5'
          : 'bg-transparent border-b border-transparent'
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-14 h-16 md:h-20 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <span className="relative flex h-2 w-2">
            <span className="absolute inline-flex h-full w-full rounded-full bg-[#EA580C] animate-soft-pulse"></span>
            <span className="relative inline-flex rounded-full h-2 w-2 bg-[#EA580C]"></span>
          </span>
          <span className="text-[11px] tracking-[0.22em] font-medium text-neutral-600 uppercase">
            The Rebrand · 2026
          </span>
        </div>
        <button
          onClick={onJoin}
          className="group text-[11px] tracking-[0.22em] font-medium text-neutral-800 uppercase hover:text-[#EA580C] transition-colors duration-200 flex items-center gap-2"
        >
          Join the waitlist
          <ArrowRight className="w-3.5 h-3.5 opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300" />
        </button>
      </div>
    </header>
  );
}
